/**
 * Normalizações de texto compartilhadas pelas primitivas.
 *
 * Vivem fora dos componentes porque um arquivo que exporta componente e função
 * ao mesmo tempo quebra o recarregamento rápido do Vite.
 */

/** Colapsa espaços e remove as bordas, sem mexer na caixa que o usuário quis. */
export function normalizeComboboxValue(value: string): string {
  return value.trim().replace(/\s+/g, " ");
}

/** Forma comparável: sem acento, sem caixa e sem espaço duplicado. */
export function comparableText(value: string): string {
  return normalizeComboboxValue(value)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}
